import React from "react";
import Icon from "../../../components/ui/Icon";
import { Header, IconBadge, Titles, Title, Sub, ClearButton } from "./CartHeader.styles";

interface CartHeaderProps {
  count: number;
  onClearCart: () => void;
}

export default function CartHeader({ count, onClearCart }: CartHeaderProps) {
  return (
    <Header>
      <IconBadge>
        <Icon name="bag" size={20} />
      </IconBadge>
      <Titles>
        <Title>Meu Carrinho</Title>
        <Sub>
          {count} {count === 1 ? "item" : "itens"}
        </Sub>
      </Titles>
      <ClearButton type="button" onClick={onClearCart}>
        Limpar Carrinho
      </ClearButton>
    </Header>
  );
}
